<template>
  <section
    :style="computedStyle"
    class="BackgroundSection bg-cover bg-no-repeat bg-center section"
  >
    <slot/>
  </section>
</template>

<script>
/**
 * @module BackgroundSection
 */
export default {
  name: 'BackgroundSection',
  props: {
    image: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedStyle () {
      return { backgroundImage: `url(${require(`@/assets/images/${this.image}`)})` }
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
